import { DatePipe } from "@angular/common";
import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { Observable, forkJoin, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ResultsSearchService } from "../../home/results-search.service";
import { UserService } from "../../pages/com.usblick.common/auth/user.service";
import { RestService } from "../../shared/rest.service";
import { ItineraryService } from "../../shared/itinerary.service";
import { ModalLoadingComponent } from "../../shared/modal-loading/modal-loading.component";
import { MatDialog } from "@angular/material/dialog";
import { MaterialModalConfirmComponent } from "../../shared/material-modal-confirm/material-modal-confirm.component";
import { MaterialModalAlertComponent } from "../../shared/material-modal-alert/material-modal-alert.component";
import { AddressesService } from '../../home/search-box/service/addresses.service';
import { NotificationService } from 'app/shared/notifications/notification.service';

@Component({
  selector: "usb-card-itinerary",
  templateUrl: "./card-itinerary.component.html",
  styleUrls: ["./card-itinerary.component.scss"],
  providers: [AddressesService],
})
export class CardItineraryComponent implements OnInit {
  items: any[] = [1, 2, 3, 4, 5, 6];

  @Input() item: any;
  @Input() index: any;
  @Input() _status: string;
  @Input() reservation: any;
  @Input() itinerary: any;
  @Input() showTextChangeDetailsProducts: boolean;
  @Input() getClientsSettingAppBooking: any;
  @Input() currencies: any[];
  @Input() currencyAgency: any;
  @Output() reserve = new EventEmitter<any>();
  @Output() delete = new EventEmitter<string>();
  @Output() cancel = new EventEmitter<string>();
  @Output() updateIti = new EventEmitter<string>();
  @Output() modifications = new EventEmitter<string>();
  @Output() reloadItinerary = new EventEmitter<string>();
  @Output() loadingSplash = new EventEmitter<string>();
  @Output() partialSelection = new EventEmitter<{id: number, selected: boolean}>();
  @Input() partialReserve: boolean;
  @Input() changePriceFromReserve: boolean;
  @Input() itemProduct: any[] = [];

  itemHasPenality: boolean = false;
  //reservation: any;
  status: string;
  selected: boolean;
  modifications_: boolean;
  @Output() itemToPartial = new EventEmitter<number>();

  constructor(
    private resultsSearch: ResultsSearchService,
    private router: Router,
    private _restService: RestService,
    public userService: UserService,
    public serviceItinerary: ItineraryService,
    private dialog: MatDialog,
    private _addressService: AddressesService,
    private notificationService: NotificationService,
  ) {
    this.status = "non-updated";
    this.selected = false;
  }

  ngOnInit() {
  }


  _reloadItinerary() {
    this.reloadItinerary.emit();
  }


  acceptNewPrice() {
    this.status = "updated";
    this.item.modifications = false;
    this.modifications_ = true;
    this.modifications.emit(this.item);
  }

  deleteItem(id: string) {
    this.delete.emit(id);
  }

  cancelReservations(id: string) {
    this.cancel.emit(id);
  }

  /// modal loading
  openModalLoading(data: any) {
    var dialogRef = this.dialog.open(ModalLoadingComponent, {
      width: "650px",
      id: "loadModal",
      data: data,
      disableClose: true,
    });

    /* dialogRef.afterClosed().subscribe(result => {
      });*/
  }

  select() {
    this.selected = this.selected ? false : true;
  }

  reserveItem() {
    this.reserve.emit(this.item);
  }

  updateItem(previousState: string) {


    //  let newPrice = this.item.newPrice;
    // this.item.newPrice = -1;
    // this.item.available = false;        // en true sale  non-available
    //this.item.roomAvailable = false;    // en true sale room-non-available
    //this.item.modifications = true;     // true parq q haya una modificación

    //actualizar la rentalibidad del nuevo precio
    // eslint-disable-next-line max-len

    // this.item.modifications = false; // TEMPORAL 11 NOVIEMBRE 2021

    if (this.item.verified) { // verifica si se hizo la verificacion en en servidor
      if (!this.item.modifications) {
        this.status = "without-changes";
      } else {
        if (this.item.available) {
          if (this.item.roomAvailable) {
            if (!this.item.samePrice) {
           //   this.item.newNetPriceUsblick = -1;
              // eslint-disable-next-line max-len
           /*   this.serviceItinerary.getProfitability(this.item.newPrice, this.item.item.category_id, this.item.item.providerId).subscribe((data: any) => {
                  console.log("data split updateItem ", data);
                  this.item.newNetPriceUsblick = data.netprice; /// data.split('-')[0];
                  const newNetPriceAgent = this.item.newNetPriceUsblick / (1 - this.item.item.percentageAgent / 100);
                  this.item.newNetPriceAgent = parseFloat(newNetPriceAgent.toFixed(2));
                  this.item.percentage = data.percentage; /// data.split('-')[2];
                });*/

              this.status = "price-non-available";
            }
          } else {
            // eslint-disable-next-line max-len
         /* eslint-disable-next-line , , ,  */
            this.status = "room-non-available";
          }
        } else {
          this.status = "non-available";
        }
      }
    } else {
      this.status = "not-verified";
    }

  }

  getImage(): string {
    let image;
    switch (this.item.item.categoryName) {
      case "DISNEY":
        image = this.item.item.hotel.additionalInfo.images[0].image;
        break;
      default:
        image = "assets/img/app/hotel_default.png";
        break;
    }
    return image;
  }

  _itemToPartial(qty: number) {
    //this.qtyItemsToPartial = this.qtyItemsToPartial + qty;
    this.itemToPartial.emit(qty);
  }

  makePayload(event: any) {

    // console.clear();
    const item = event.item;
    const action = event.action;
    const pairedItem = event.pairedItem;
      let payload: any;
      let form: any;
      switch(item.category_id) {
        case 4: // PARQUES TEMATICOS (mismo formato que alojamiento)
        case 1:
          // Deep clone para no mutar item.payloadUpdate (se reusa en detail modal).
          payload = item.payloadUpdate?.products?.[0]
            ? JSON.parse(JSON.stringify(item.payloadUpdate.products[0]))
            : null;
          if (payload) {
            payload.destination = item.destination?.iata_code
              || item.form?.destination?.city_iata_code
              || payload.destination
              || '';
            delete payload.hotels;
          }
          form = item.form;
        break;
        case 2:
          payload = item.payloadUpdate?.products?.[0];
          form = item.form;
        break;
        case 6:
          payload = item.payload?.[0];
          form = item.form;
        break;
        case 8:

          payload = item.payload?.[0];
          form = item.formTransport;

          if(payload?.providerId) {
            payload.providersId = payload?.providerId || null;
          }

          // payload = this.serviceItinerary.verifiedValuePayloadDestinaiton(payload);

          // Si se elimina un solo tramo pero el payload original es de ida y vuelta
          // (porque el vehículo es de ida y vuelta, o porque el tramo pareado no cumplía
          // las condiciones para eliminarse junto), se busca solo como ida.
          if (action === 'delete' && payload?.transfers?.oneWay === false) {
            payload = JSON.parse(JSON.stringify(payload));
            payload.dropoffDate = null;
            if (payload.transfers) {
              payload.transfers.dropoffTime = null;
              payload.transfers.oneWay = true;
            }

            if (form) {
              form = JSON.parse(JSON.stringify(form));
              form.dropOff = '';
              form.pickUp = '';
              form.secondArrivalDate = null;
              form.secondTime = null;
            }
          }

          // pickupLocation/dropoffLocation puede venir de un payload viejo con
          // origin/destination desactualizado (ej: código de país en vez de IATA
          // de ciudad) - se contrasta contra _addressService antes de buscar.
          this.contrastTransferLocations(payload).subscribe((correctedPayload) => {
            this.submitPayloadSearch(correctedPayload, form, item, action, pairedItem);
          });
          return;
        case 10:
          payload = item.payload;
          form = item.form;
        break;
      }

      this.submitPayloadSearch(payload, form, item, action, pairedItem);
  }

  loadMultidestinationResult(payload: any) {
    if (payload !== undefined && payload.length > 0) {
      let _results = [];
      this.resultsSearch._setPayload(payload);

      for (let i = 0; i < payload.length; i++) {
        this._restService.doPost("app", "search", payload[i]).subscribe(
          (response: any) => {
            if (response !== null && response.results !== null) {
              this._setSearchIdInResults(response);
            }

            _results[i] = response.results;
            _results[i].qtyPax = payload[i].qtyPax;
            _results[i].others = payload[i].others;
            _results[i].destination = payload[i].destination;
            _results[i].categoryName = payload[i]?.categoriesId?.[0] === 4 ? "PARKS" : "HOTELS";
            _results[i].payload = payload[i];

            if (!response.results.length) {
              _results[i].noResultMessage = "No results found for the search";
            }

            if (i === payload.length - 1) {

              this.resultsSearch._setResponse(_results);
              this.resultsSearch._setOrigin("MULTIDESTINATION");
              //this.spinner.hide();
              this.router.navigate(["/results"]);
            }
          },
          (error) => {
            //this.spinner.hide();
            //this._results[i] = [];
            //this._results[i].noResultMessage = 'No results found for the search';
            //this._findData = false;
            //this._itineraryService.sendMessageSubscriptorLoading(false);
            console.log(error);
          }
        );
      }
    }
  }

  //metodos auxiliares
  _setSearchIdInResults(response: any) {
    response.results.forEach((obj) => {
      obj.searchId = response.searchId;
    });
  }

  _setPayloadArray(destinations: any) {
    let _payloadArray = [];
    let payload = this.item.item.payloadUpdate.products[0];
    let arrivalDate = this.userService.itineraryActive[0].arrivalDate;


    for (let i = 0; i < destinations.length; i++) {
      let arrival = null;
      if (payload !== undefined && payload !== null) {
        if (payload.others !== undefined && payload.others !== null) {
          var qtyAdults = 0;
          if (payload.others.hotels) {
            payload.others.hotels.roomConfiguration.forEach((room) => {
              qtyAdults += parseInt(room.adults);
            });
          }
        }
      }
      if (arrivalDate !== undefined || arrivalDate !== null) {
        arrival = new Date(i === 0 ? arrivalDate : _payloadArray[i - 1].departureDate);
        _payloadArray[i] = {
          arrivalDate: i === 0 ? arrivalDate : _payloadArray[i - 1].departureDate,
          categoriesId: [1],
          departureDate: this.userService.itineraryActive[0].destination[i].destination_info.departure,
          origin: "MULTIDESTINATION",
          destination: destinations[i]["cityIataCode"],
          others: payload.others,
          priceFrom: payload.priceFrom,
          priceTo: payload.priceTo,
          providersId: payload.providersId,
          qtyPax: qtyAdults,
          qtyProduct: 1,
        };
      } else {
      }
    }

    return _payloadArray;
  }

  _handleResponse(response: any, categoryName: string, payload: any) {
    if (response && response.results != null) {
      try {
        let _resultsQuery: any;
        _resultsQuery = response.results;
        _resultsQuery.categoryName = categoryName;
        _resultsQuery.arrivalDate = payload.arrivalDate;
        _resultsQuery.destination = this.item.item.destination.iata_code;
        if (!response.results.length) {
          _resultsQuery.noResultMessage = "No results found for the search";
        }
        const arrayResults = [_resultsQuery];

        this.resultsSearch._setResponse(arrayResults);
      } catch (e) {
        console.log("error", e);
      }
    }
  }


  //multidestinetion add extras
  _getMonthName(month: number) {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Octr", "Nov", "Dec"];
    if (month !== null) {
      return monthNames[month - 1];
    }
  }

  reSearch(event) {
    // console.log('event research ->', event);
    this.makePayload(event);
  }


  loadingSplashCancel(event:any){
    this.loadingSplash.emit(event);
  }


  /**
   * Etiqueta a mostrar en el badge de origen del producto.
   * 'Web Offline Request' es un valor interno del backend: en pantalla solo
   * tiene sentido 'Offline'. Cualquier otro source se muestra tal cual.
   */
  getSourceLabel(source: string | undefined | null): string {
    if (!source) {
      return '';
    }
    return source === 'Web Offline Request' ? 'Offline' : source;
  }

  getIconCategory(categoryName: string, item: any): string {
    switch (categoryName) {
      case 'TOURS':
        if(item.item.subCategoryId === 6) {
          return '/assets/img/app/categories-search-box/road-map.svg';
        }
        if(item.item.subCategoryId === 9) {
          return '/assets/img/app/categories-search-box/combi-ticket.svg';
        }
      case 'PARKS':
        return '/assets/img/app/categories-search-box/parks.svg';
      case 'HOTELS':
        return '/assets/icons/itinerary/bed-svgrepo-com.svg';
      case 'PTHEMES':
        return '/assets/img/app/icon-pthemes-green.svg';
      case 'TRANSPORTS':
        return '/assets/icons/itinerary/school_15476203.svg';
      case 'DISNEY':
        return '/assets/img/app/disney-green.svg';
      case 'RENT-A-CAR':
        return '/assets/img/app/categories-search-box/car-compact.svg';
      case 'INSURANCE':
        return '/assets/img/app/categories-search-box/icon-seguro.svg';
      case 'BOATS':
        return '/assets/img/app/categories-search-box/boat.svg';
      case 'CRUISES':
        return '/assets/img/app/icon-crucero-green.svg';
      case 'FLIGHTS':
        return '/assets/img/app/categories-search-box/AEREO.svg';
      default:
        return '/assets/img/app/icon-maletas-green.svg';
    }
  }

  onPartialSelection(event: {id: number, selected: boolean}) {

  // Re-emitir el evento al abuelo (itinerary-detail)
  this.partialSelection.emit(event);
}

// 1px solid #e0e0e0;
getSyncStatusStyle(item: any): string {

  if(item.item.syncProduct) {
    if(item.item.syncProduct.alert) {
      if(item.item.syncProduct.priceNonAvailable || item.item.syncProduct.codeLabelStatus === 'PRODUCT_CANCELLATION_POLICY_CHANGED') {
         return '2px solid #00d397';
      } else {
              return '2px solid #d60159';
      }
    } else {
      return '1px solid #e0e0e0';
    }
  }

  return '1px solid #e0e0e0';
}

hasPenality(event: any): void {
    setTimeout(() => {
        // ✅ Usar el valor que viene del evento
        this.itemHasPenality = event;
    });
}

  private submitPayloadSearch(payload: any, form: any, item: any, action: any, pairedItem: any): void {
      // Un ítem de cotización offline puede no traer el payload de búsqueda con
      // el que se reconstruye la búsqueda (no se generó desde el buscador). Sin
      // payload no hay nada que buscar: se informa y se corta el flujo en vez
      // de mandar un search inválido al backend.
      if (!payload) {
        this.dialog.closeAll();
        this.serviceItinerary.notifyModalClosed(true);
        this.notificationService.info('Este producto no tiene una búsqueda asociada, no se puede re-cotizar.');
        return;
      }

      const _payload: any[] = [payload];

      localStorage.setItem("form", JSON.stringify(form));
      localStorage.setItem("payload", JSON.stringify(_payload));
      this.openModalLoading(JSON.parse(localStorage.getItem("payload")));


      this._restService.doPost("app", "search", payload).subscribe(
        (response: any) => {

          if (response !== null && response.results && Array.isArray(response.results) && response.results.length > 0) {

            const payloadArray = [payload];
            this.resultsSearch._setPayload(payloadArray);
            // localStorage.setItem("form", JSON.stringify(form));
            // localStorage.setItem("payload", JSON.stringify(payloadArray));
            this.resultsSearch._setOrigin(this.item.item.categoryName);

            this._setSearchIdInResults(response);
            if (response.results.length > 0) {
              if(action === 'delete') {
                this.serviceItinerary.remove(item !== undefined ? item : this.item);
              } else if(action === 'deleteRoundTrip') {
                this.serviceItinerary.remove(item !== undefined ? item : this.item);
                if (pairedItem) {
                  this.serviceItinerary.remove(pairedItem);
                }
              }
              this._handleResponse(response, this.item.item.categoryName, item);
              this.dialog.closeAll();
              this.serviceItinerary.notifyModalClosed(true);
              if((item.category_id === 1 || item.category_id === 4)) {
                this.resultsSearch.emitReloadSearchHotel();
              }
              setTimeout(() => {
                 this.router.navigate(["/results"]);
              }, 200);

            } else {
              var dialogRef = this.dialog.open(MaterialModalAlertComponent, {
                height: "auto",
                width: "350px",
                data: "No se encontraron Resultados",
                disableClose: true,
              });
            }
          } else {
             this.dialog.closeAll();
             this.serviceItinerary.notifyModalClosed(true);
             var dialogRef = this.dialog.open(MaterialModalAlertComponent, {
                height: "auto",
                width: "350px",
                data: "No se encontraron Resultados",
                disableClose: true,
              });



          }
        },
        (error) => {
          const message = "Ocurrió un error al intentar encontrar productos";
          this.dialog.closeAll();
          var dialogRef = this.dialog.open(MaterialModalConfirmComponent, {
            width: "450px",
            data: {message: message},
            disableClose: true,
          });
          dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              this.makePayload(item);
            } else {
              this.dialog.closeAll();
            }
          });
        }
      );

  /*  } else {
      //Es multidestination
      console.log("Multidestination research");

      var _destinations = [];
      let itinerary = this.userService.itineraryActive;
      if (itinerary[0].destination.length > 0) {
        for (let i = 0; i < itinerary[0].destination.length; i++) {
          const arrival = itinerary[0].destination[i].destination_info.arrival.split("-");
          _destinations.push({
            cityIataCode: itinerary[0].destination[i].iata_code,
            cityName: itinerary[0].destination[i].destination_info.cityName,
            nights: itinerary[0].destination[i].destination_info.nights,
            adults: itinerary[0].destination[i].destination_info.adults,
            childs: itinerary[0].destination[i].destination_info.childs,
            rooms: itinerary[0].destination[i].destination_info.rooms,
            roomsDist: itinerary[0].destination[i].destination_info.roomDist,
            yy: this.datePipe.transform(itinerary[0].destination[i].destination_info.arrival, "yy"),
            mm: this._getMonthName(arrival[1]),
            dd: arrival[2],
          });
        }
      }

      console.log("_destinations", _destinations);
      let payloadArray = this._setPayloadArray(_destinations);
      console.log("payloadArray", payloadArray);
      this.loadMultidestinationResult(payloadArray);
    } */
  }

  /**
   * Busca en `_addressService` (por name) el registro original de pickupLocation/dropoffLocation
   * y corrige `origin`/`destination` si el IATA de ciudad guardado en el payload quedó desactualizado
   * (caso típico de payloads viejos: guardaron código de país en vez de IATA de ciudad).
   * Si no encuentra el registro, deja el payload como está y avisa por console.warn.
   */
  private contrastTransferLocations(payload: any): Observable<any> {
    const pickupLocation = payload?.transfers?.pickupLocation;
    const dropoffLocation = payload?.transfers?.dropoffLocation;

    if (!pickupLocation || !dropoffLocation) {
      return of(payload);
    }

    return forkJoin({
      pickupCityIata: this.findCityIata(pickupLocation),
      dropoffCityIata: this.findCityIata(dropoffLocation),
    }).pipe(
      map(({ pickupCityIata, dropoffCityIata }) => {
        if (pickupCityIata && pickupCityIata !== pickupLocation.origin) {
          pickupLocation.origin = pickupCityIata;
        }
        if (dropoffCityIata && dropoffCityIata !== dropoffLocation.destination) {
          dropoffLocation.destination = dropoffCityIata;
        }
        return payload;
      })
    );
  }

  /**
   * Busca por `name` en `_addressService.getLocationsAll` (categoría TRANSFERS) y, entre
   * todos los grupos de la respuesta (airports/hotels/cities/...), busca la entrada cuyo
   * `id` matchee. Nota: para type 'city' en categoría TRANSFERS el bucket viene de
   * addressGoogle (otro shape, con place_id en vez de id numérico) - el match por id puede
   * no encontrar nada en ese caso, y queda cubierto por el console.warn de "no encontrada".
   */
  private findCityIata(location: { id: number; name: string; type?: string }): Observable<string | null> {
    return this._addressService.getLocationsAll(location.name, undefined, false, 'TRANSFERS').pipe(
      map((groups: any[]) => {
        for (const group of groups || []) {
          const arrayKey = Object.keys(group).find((key) => key !== 'type');
          const entries: any[] = (arrayKey && group[arrayKey]) || [];
          const match = entries.find((entry) => entry?.id === location.id);
          if (match) {
            return match.city_iata ?? match.iata ?? match.city_iata_code ?? null;
          }
        }
        console.warn('[contrastTransferLocations] No se encontró la location para contrastar:', location);
        return null;
      })
    );
  }

}
